<template>
  <main class="perdu-page flex flex-col justify-center items-center min-h-[60vh] py-16 sm:py-24 px-4 sm:px-6">
    <section class="text-center max-w-[676px] mx-auto">
      <h1 class="font-barlow-condensed font-bold text-white uppercase text-4xl sm:text-5xl lg:text-6xl leading-tight mb-4 sm:mb-6">
        Dommage...
      </h1>
      <p class="font-barlow-condensed font-bold text-[#FEEFC7] uppercase text-3xl sm:text-4xl lg:text-5xl leading-tight mb-6 sm:mb-8">
        C'est perdu pour aujourd'hui.
      </p>
      <p class="font-barlow-condensed font-bold text-white text-lg sm:text-xl lg:text-2xl leading-snug">
        Mais bonne nouvelle, vous pouvez tenter à nouveau votre chance
        dès demain et jusqu'au 28 février 2027 en achetant un produit
        Petit Navire éligible.
      </p>
    </section>
  </main>
</template>

<script>
import { clearGameResult, getGameResult, isPerduResult } from "@/gameResult";

export default {
  name: "PerduView",
  beforeMount() {
    const gameResult = getGameResult();

    if (!isPerduResult(gameResult)) {
      window.location.href = "/formig";
      return;
    }

    clearGameResult();
  },
};
</script>

<style scoped>
.perdu-page {
  background-color: #0d2651;
  background-image: url("@/assets/images/fond-perdu.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
